import React, { useEffect, useState, useRef } from 'react'
import Swal from 'sweetalert2';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { auth, db } from '../firebase';
import "../App.css";
import Menu from '../panel/Menu';

function Dashboard() {
    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    });
    const [userData, setUserData] = useState();

    const [depcount, setdepcount] = useState(0);
    const [prodcount, setprodcount] = useState(0);
    const [pocount, setpocount] = useState(0);
    const [reqcount, setreqcount] = useState(0);


    useEffect(() => {
        auth.onAuthStateChanged((user) => {
            setUserData(user);
            fetchData1()
        });
    }, [userData]);

    const fetchData1 = async () => {
        try {
            if (userData) {
                // Creating queries in advance
                const queries = [
                    query(collection(db, "departments")),
                    query(collection(db, "products")),
                    query(collection(db, "poregisters"), where("type", "==", "Purchase Order")), // Ensure type has no extra space
                    query(collection(db, "poregisters"), where("type", "==", "Requisitions"))
                ];

                // Fetching all data concurrently
                const [snapshot5, snapshot6, snapshot7, snapshot8] = await Promise.all(queries.map(q => getDocs(q)));

            
                setdepcount(snapshot5.size);
                setprodcount(snapshot6.size);
                setpocount(snapshot7.size);
                setreqcount(snapshot8.size);
            }
        } catch (error) {
            Toast.fire({
                icon: "error",
                title: error.message
            });
            console.error("Firestore Query Error:", error.message);
        }
    };





    return (
        <div>
            <Menu />
            <div className="content-wrapper" style={{ backgroundColor: '#fff' }}>
                <section className="content"><br />
                    <div className="container-fluid">
                        <button className="btn btn-secondary " >|| Dashboard ||</button><br /><br />
                        <div className="row">
                            <div className="col-lg-3 col-6">
                                <div className="small-box bg-pink">
                                    <div className="inner">
                                        <h3>{depcount}</h3>
                                        <p>Departments</p>
                                    </div>
                                    <div className="icon">
                                        <i className="fas fa-users" />
                                    </div>

                                </div>
                            </div>
                            <div className="col-lg-3 col-6">
                                <div className="small-box bg-orange">
                                    <div className="inner">
                                        <h3>{prodcount}</h3>
                                        <p>Products</p>
                                    </div>
                                    <div className="icon">
                                        <i className="fas fa-users" />
                                    </div>

                                </div>
                            </div>
                            <div className="col-lg-3 col-6">
                                <div className="small-box bg-purple">
                                    <div className="inner">
                                        <h3>{pocount}</h3>
                                        <p>Purchase Orders</p>
                                    </div>
                                    <div className="icon">
                                        <i className="fas fa-users" />
                                    </div>

                                </div>
                            </div>
                            <div className="col-lg-3 col-6">
                                <div className="small-box bg-blue">
                                    <div className="inner">
                                        <h3>{reqcount}</h3>
                                        <p>Requisitions</p>
                                    </div>
                                    <div className="icon">
                                        <i className="fas fa-users" />
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </section>

            </div >


        </div >
    )
}

export default Dashboard
